export default __webpack_public_path__ + "static/media/b1c256bd-76d0-4fdb-8ad3-21bf2740c28d.d711a383.jpg";